import { Helmet } from "react-helmet";
import { Navigate } from "react-router-dom";

import { useConsults } from "@/hooks/care/useConsults";
import { useLoggedInUser } from "@/hooks/useLoggedInUser";

export const IndexRoute = () => {
  const { consults, loading } = useConsults();
  const currentUser = useLoggedInUser();
  const mostRecentConsult = consults?.[0];
  const basePath = "/treatments";

  if (loading) return null;

  const indexRoute = (() => {
    if (
      mostRecentConsult?.type === "ungated-rx" &&
      ["OR", "ST"].includes(mostRecentConsult?.status || "")
    ) {
      return `${basePath}/intake/`;
    }
    if (
      (mostRecentConsult?.type === "male-partner" &&
        ["IN", "OR", "ST"].includes(mostRecentConsult?.status || "")) ||
      currentUser?.identity?.registrationRoute === "male_partner"
    ) {
      return `${basePath}/male-partner/intake/start`;
    }
    if (currentUser && currentUser.identity.isProvider) {
      return "/provider/";
    }

    return "/tests/";
  })();

  return (
    <>
      <Helmet>
        <title>Evvy - Your Account</title>
        <meta name="description" content="Visit your Evvy Account." />
      </Helmet>
      <Navigate replace to={indexRoute} />
    </>
  );
};
